// extracted by mini-css-extract-plugin
export default {"table":"Table_table__7VuZZ","cell":"Table_cell__j0dzJ","header":"Table_header__o99OV","key":"Table_key__eiK1U","value":"Table_value__8fF+Q"};